import { formatDateAndTimeLong } from '../../../utils/dateHelpers'
import { IResourceActivityCsvResponse } from './DownloadResourceActivityCSV'
import { t } from '@lingui/macro'

export const prepareCSVResourceActivityExport = (
  data: IResourceActivityCsvResponse[]
) =>
  data.map((row) => ({
    [t`Views count`]: row.viewsCount,
    [t`User name`]: row.displayName,
    [t`User id`]: row.userId,
    [t`Last viewed at`]: formatDateAndTimeLong(row.lastViewedAt)
  }))
